import { api } from './client'

export async function getClientsRegistry(params?: {
  search?: string; offset?: number; limit?: number
}): Promise<{ total: number; clients: unknown[] }> {
  const res = await api.get('/api/v1/registry/clients', { params })
  return res.data
}

export async function getOrdersRegistry(params?: {
  status?: string; offset?: number; limit?: number
}): Promise<{ total: number; orders: unknown[] }> {
  const res = await api.get('/api/v1/registry/orders', { params })
  return res.data
}

export async function getPaymentsRegistry(params?: {
  overdue_only?: boolean; offset?: number; limit?: number
}): Promise<{ total: number; payments: unknown[] }> {
  const res = await api.get('/api/v1/registry/payments', { params })
  return res.data
}

// Fetch xlsx with JWT auth header, then trigger browser download
async function downloadExcel(path: string, filename: string): Promise<void> {
  const res = await api.get(path, { responseType: 'blob' })
  const url = URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export const exportClients  = () => downloadExcel('/api/v1/registry/clients/export',  'clients.xlsx')
export const exportOrders   = () => downloadExcel('/api/v1/registry/orders/export',   'orders.xlsx')
export const exportPayments = () => downloadExcel('/api/v1/registry/payments/export', 'payments.xlsx')
